import { AnsokanFormStepOneModel, FileUploadText } from '../models/ansokan.model';
import { SkyddadYrkestitelFormStepOneModel } from '../models/skyddadyrkestitel.model';
import { SpecialistbevisAnsokanFormStepOneModel } from '../models/specialistbevisansokan.model';

export const findFileUploadTextByFieldName = (
  fieldName: string,
  fileUploadTexts: FileUploadText
): FileUploadText | undefined => {
  return Object.values(fileUploadTexts).find((obj) => obj?.DHSCategory?.FieldName === fieldName);
};

export const getFileUploadTexts = (
  model: AnsokanFormStepOneModel | SpecialistbevisAnsokanFormStepOneModel | SkyddadYrkestitelFormStepOneModel
) => {
  return Object.fromEntries(
    Object.entries(model).filter(([key, value]) => key?.startsWith('FileUploadText') && value !== null)
  );
};
